import { render, staticRenderFns } from "./about-us.vue?vue&type=template&id=22bdc98a&scoped=true"
import script from "./about-us.vue?vue&type=script&lang=js"
export * from "./about-us.vue?vue&type=script&lang=js"
import style0 from "./about-us.vue?vue&type=style&index=0&id=22bdc98a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bdc98a",
  null
  
)

export default component.exports